import { Col, Row } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { ClipboardCopy, EmailLink, FormItem, FormText, SapId } from 'ui';

const Payer = ({
  data: {
    number,
    name,
    name2,
    vatNumber,
    street,
    houseNumber,
    city,
    postalCode,
    language,
    countryName,
    phoneNumber,
    mobileNumber,
    email,
  },
  intl,
}) =>
  <>
    <Row type='flex' gutter={16}>
      <Col md={12} sm={24} xs={24}>
        <FormItem label={intl.formatMessage({ id: 'common.labels.NAME' })}>
          <FormText>{name}</FormText>
        </FormItem>
      </Col>
      <Col md={12} sm={24} xs={24}>
        <FormItem label={intl.formatMessage({ id: 'common.labels.NAME_2' })}>
          <FormText>{name2}</FormText>
        </FormItem>
      </Col>
    </Row>
    <Row type='flex' gutter={16}>
      <Col md={12} sm={24} xs={24}>
        <FormItem label={intl.formatMessage({ id: 'common.labels.STREET' })}>
          <FormText>{street}</FormText>
        </FormItem>
      </Col>
      <Col md={12} sm={24} xs={24}>
        <FormItem label={intl.formatMessage({ id: 'common.labels.HOUSE_NUMBER' })}>
          <FormText>{houseNumber}</FormText>
        </FormItem>
      </Col>
    </Row>
    <Row type='flex' gutter={16}>
      <Col md={12} sm={24} xs={24}>
        <FormItem label={intl.formatMessage({ id: 'common.labels.POSTAL_CODE' })}>
          <FormText>{postalCode}</FormText>
        </FormItem>
      </Col>
      <Col md={12} sm={24} xs={24}>
        <FormItem label={intl.formatMessage({ id: 'common.labels.CITY' })}>
          <FormText>{city}</FormText>
        </FormItem>
      </Col>
    </Row>
    <Row type='flex' gutter={16}>
      <Col md={12} sm={24} xs={24}>
        <FormItem label={intl.formatMessage({ id: 'common.labels.COUNTRY' })}>
          <FormText>{countryName}</FormText>
        </FormItem>
      </Col>
      <Col md={12} sm={24} xs={24}>
        <FormItem label={intl.formatMessage({ id: 'common.labels.EMAIL' })}>
          <ClipboardCopy onlyCopyThroughIcon={true}>
            <EmailLink href={`mailto:${email}`}>{email}</EmailLink>
          </ClipboardCopy>
        </FormItem>
      </Col>
    </Row>
    <Row type='flex' gutter={16}>
      <Col md={12} sm={24} xs={24}>
        <FormItem label={intl.formatMessage({ id: 'common.labels.PHONE_NUMBER' })}>
          <FormText><ClipboardCopy>{phoneNumber}</ClipboardCopy></FormText>
        </FormItem>
      </Col>
      <Col md={12} sm={24} xs={24}>
        <FormItem label={intl.formatMessage({ id: 'common.labels.MOBILE_NUMBER' })}>
          <FormText><ClipboardCopy>{mobileNumber}</ClipboardCopy></FormText>
        </FormItem>
      </Col>
    </Row>
    <Row type='flex' gutter={16}>
      <Col md={12} sm={24} xs={24}>
        <FormItem label={intl.formatMessage({ id: 'common.labels.SAP_NUMBER' })}>
          {/* use the ID component to tansform to 'readable' ID (without leading zeroes) */}
          <SapId originalId={number}>{id => <FormText>{id}</FormText>}</SapId>
        </FormItem>
      </Col>
      <Col md={12} sm={24} xs={24}>
        <FormItem label={intl.formatMessage({ id: 'common.labels.LANGUAGE' })}>
          <FormText>{language}</FormText>
        </FormItem>
      </Col>
    </Row>
    <Row type='flex' gutter={16}>
      <Col md={12} sm={24} xs={24}>
        <FormItem label={intl.formatMessage({ id: 'common.labels.VAT_NUMBER' })}>
          <FormText>{vatNumber}</FormText>
        </FormItem>
      </Col>
    </Row>
  </>;

Payer.propTypes = {
  data: PropTypes.shape({
    number: PropTypes.string,
    name: PropTypes.string,
    name2: PropTypes.string,
    vatNumber: PropTypes.string,
    street: PropTypes.string,
    houseNumber: PropTypes.string,
    city: PropTypes.string,
    postalCode: PropTypes.string,
    language: PropTypes.string,
    countryName: PropTypes.string,
    phoneNumber: PropTypes.string,
    mobileNumber: PropTypes.string,
    email: PropTypes.string,
  }),
  intl: PropTypes.object,
};

export default injectIntl(Payer);
